import R, {indexBy, prop, propEq} from "ramda";
import {normalizeIngredients} from "../../lib/utils";
import set from "lodash/set";
import find from "ramda/src/find";

const setState = (resource) => (state, payload) => set(state, resource, payload);

export default {
  fetch(state, {resources, recipes, lines, ingredients}) {
    state.resources = resources;
    state.ingredients = ingredients;
    state.lines = lines;
    state.recipes = recipes;
    state.recipe = R.find(propEq('name', state.currentRecipe), recipes);
  },
  set(state, payload) {
    return R.mapObjIndexed((val, key) => {
      state[key] = val;
    }, payload)
  },


  setPeriod: setState('period'),
  setCapability: setState('capability'),
  selectCurrency: setState('currencyCode'),
  preloadData(state, {currency, recipe, line}) {
    const ingredients = normalizeIngredients(state.ingredients, currency, recipe, line);
    const {
      energyTariff,
      price,
      rent,
      tariff
    } = indexBy(prop('name'), normalizeIngredients(state.resources, currency, recipe, line));

    state.source = {
      ingredients,
      energyTariff,
      priceOfSq: price,
      price,
      rent,
      tariff
    }
  },
  setIngAmount(state, [name, value]) {
    const ing = find(propEq('name', name), state.source.ingredients);
    ing.amount.value = value;
  },
  setIngPrice(state, [name, value]) {
    const ing = find(propEq('name', name), state.source.ingredients);
    ing.price.value = value;
  },
  setResAmount(state, [name, value]) {
    const ing = prop(name, state.source);
    ing.amount.value = value;
  },
  setResPrice(state, [name, value]) {
    const ing = prop(name, state.source);
    ing.price.value = value;
  },
  selectRecipe() {

  }
}
